import React from "react";
import "../../styles/WoodsSite.css";
import masterplanImage from "../../assets/meadows-images/vessella-meadows-layout.avif";

export default function WoodsMasterplan() {
  return (
    <section className="woods-masterplay-section" id="woods-masterplay">
      <img
        src={masterplanImage}
        alt="Woods masterplan layout"
        className="woods-masterplay-image"
        loading="lazy"
      />
    </section>
  );
}
